import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router'
import logoIndique from '../assets/img/logos/logo-indique.svg'

class Header extends React.Component {
  constructor() {
    super()
    this.handleNav = this.handleNav.bind(this)
    this.state = {
      navOpened: false,
    }
  }
  handleNav() {
    this.setState({
      navOpened: !this.state.navOpened,
    })
  }
  render() {
    return (
      <header className="header">
        <Helmet>
          <title>Indique Parceiros</title>
        </Helmet>
        <link rel="polyfill" href="https://cdn.polyfill.io/v2/polyfill.min.js" />
        <div className="container">
          <div className="row d-flex flex-wrap justify-content-between align-items-center">
            <div className="col col-md-4">
              {typeof window !== 'undefined' && !window.location.search ?
                <Link to="/">
                  <img src={logoIndique} alt="logoIndique" className="logo" />
                </Link>
                :
                <img alt="logoIndique" style={{ cursor: 'pointer' }} src={logoIndique} className="logo" />
              }
            </div>
            <div className="col col-md-4 text-right">
              <a href="http://softin.com.br/">Ir para Softin Sistemas
              </a>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./client/components/Header.js